import gql from 'graphql-tag';

// Multilingual v3: whether readers get this language (the reader's /en/ and the language switcher).
export default gql`
mutation setProjectLanguageOnline($projectId: Int!, $languageId: Int!, $online: Boolean!) {
  update_project_languages(
    where: { project_id: { _eq: $projectId }, language_id: { _eq: $languageId } },
    _set: { online: $online }
  ) {
    affected_rows
  }
}
`;
